/**
 * set-upsell.js — Upsell "Setul MOXauto complet" pe pagina de coș (v3)
 *
 * NOU: la apăsarea butonului, produsul individual e SCOS din coș
 * și înlocuit cu setul complet (nu se mai adaugă alături de el).
 *
 * Am precompletat mai jos handle-urile pe care mi le-ai dat deja
 * (prosop, wheel beast, bundle handle + variant ID). Mai trebuie
 * doar să completezi handle-ul real pentru DIRT HUNTER.
 */

(function () {
  // ── CONFIGURARE ──
  const SET_PRODUCTS = {
    'moxauto-mikrofaser-trockentuch': { name: 'Premium Mikrofasertuch' },
    'moxauto-wheel-beast-felgenreiniger': { name: 'WHEEL BEAST Felgenreiniger' },
    'moxauto-dirt-hunter-innenraumreiniger-all-in-one': { name: 'DIRT HUNTER Innenraumreiniger' }, // <-- completează
  };
  const BUNDLE_HANDLE = 'das-komplette-moxauto-set';
  const BUNDLE_VARIANT_ID = 54281344549201;
  // ─────────────────

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function checkCartAndShowUpsell() {
    try {
      const cart = await getCart();
      const handlesInCart = cart.items.map((i) => i.handle);

      if (handlesInCart.includes(BUNDLE_HANDLE)) {
        hideUpsell();
        return;
      }

      const setHandles = Object.keys(SET_PRODUCTS);
      const presentSetItems = setHandles.filter((h) => handlesInCart.includes(h));

      if (presentSetItems.length === 1) {
        showUpsell(presentSetItems[0]);
      } else {
        hideUpsell();
      }
    } catch (err) {
      console.error('MOXauto upsell: eroare la citirea coșului', err);
    }
  }

  function showUpsell(presentHandle) {
    const banner = document.getElementById('moxauto-set-upsell');
    if (!banner) return;
    const nameEl = banner.querySelector('[data-current-product]');
    if (nameEl) nameEl.textContent = SET_PRODUCTS[presentHandle].name;
    banner.style.display = 'flex';
  }

  function hideUpsell() {
    const banner = document.getElementById('moxauto-set-upsell');
    if (banner) banner.style.display = 'none';
  }

  async function swapForBundle() {
    const btn = document.getElementById('moxauto-add-bundle-btn');
    if (!btn) return;
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Wird bearbeitet...';

    try {
      // 1. Adaugă ÎNTÂI setul complet — dacă asta eșuează, nu ștergem nimic
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: BUNDLE_VARIANT_ID, quantity: 1 }] }),
      });
      const addData = await addRes.json();

      if (!addRes.ok) {
        console.error('MOXauto upsell: eroare la adăugarea bundle-ului', addData);
        alert('Das komplette Set konnte nicht hinzugefügt werden: ' + (addData.description || addData.message || 'unbekannter Fehler'));
        btn.disabled = false;
        btn.textContent = originalText;
        return;
      }

      // 2. Abia acum scoate din coș liniile produselor individuale din set
      const cart = await getCart();
      const setHandles = Object.keys(SET_PRODUCTS);
      const linesToRemove = cart.items.filter(
        (item) => setHandles.includes(item.handle) && item.handle !== BUNDLE_HANDLE
      );
      for (const line of linesToRemove) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 }),
        });
      }

      window.location.reload();
    } catch (err) {
      console.error('MOXauto upsell: eroare la swap în bundle', err);
      btn.disabled = false;
      btn.textContent = originalText;
      alert('Es ist ein Netzwerkfehler aufgetreten. Bitte prüfe die Konsole (F12) für Details.');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    checkCartAndShowUpsell();

    const addBtn = document.getElementById('moxauto-add-bundle-btn');
    if (addBtn) addBtn.addEventListener('click', swapForBundle);

    document.addEventListener('cart:updated', checkCartAndShowUpsell);
    document.addEventListener('cart:refresh', checkCartAndShowUpsell);
  });
})();